import type { agentPaths, paths } from '@crossbeam/openapi';

import createClient from 'openapi-fetch';

import appConfig from '@/config';

export function useCreateMSWClient() {
  type ApiUrl = typeof appConfig.apiBaseUrl;
  type AgentUrl = typeof appConfig.agentBaseUrl;

  type ApiConfig =
    | {
        url: ApiUrl;
        paths: paths;
      }
    | {
        url: AgentUrl;
        paths: agentPaths;
      };
  function createMSWClient<T extends ApiConfig['url']>(url: T) {
    interface Config {
      baseUrl: string;
      headers: Record<string, string | null>;
      credentials?: RequestCredentials;
    }

    const isTestMode = import.meta.env.MODE === 'test';

    const config: Config = {
      baseUrl: url,
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    if (isTestMode) {
      delete config.credentials;
    }

    /* Primarily used to set our Xbeam-Organization header which is an org uuid */
    const setCustomHeader = (
      headerName: string,
      headerValue: string | null,
    ) => {
      config.headers[headerName] = headerValue;
    };

    return {
      client: createClient<T extends ApiUrl ? paths : agentPaths>(config),
      setCustomHeader,
    };
  }

  return { createMSWClient };
}
